module.exports = __webpack_public_path__ + "img/sort.d7abf4d5.gif";